import useResponseHandler from 'features/SpilKlub/state/useResponseHandler';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { buyShares } from 'features/SpilKlub/server/requests';
import useAuth from './useAuth';
import { invalidatePoolShares } from './usePoolDetails';

const usePurchaseConfirm = ({ pool }) => {
    const queryClient = useQueryClient();
    const { userId } = useAuth();

    const { handleResponse } = useResponseHandler({
        requestHandler: buyShares,
        payload: {},
    });

    const mutationFn = async (params) => {
        const response = await handleResponse(params);
        const { numberOfShares } = params;

        // params contain all required properties of 'pool.shares' schema
        const invalidatedPoolDetails = invalidatePoolShares({
            numberOfShares,
            userId,
            pool,
        });

        queryClient.setQueryData(
            ['pool', pool.poolHash, userId],
            invalidatedPoolDetails
        );
        return response;
    };

    const mutation = useMutation({
        mutationFn,
        enabled: true,
    });
    return {
        save: mutation.mutateAsync,
        status: mutation.status,
        reset: mutation.reset,
        error: mutation.error?.message,
        isError: mutation.isError,
    };
};

export default usePurchaseConfirm;
